import { render } from "./EndGameBuddy1.vue?vue&type=template&id=9a3f7542&scoped=true"
import script from "./EndGameBuddy1.vue?vue&type=script&lang=js"
export * from "./EndGameBuddy1.vue?vue&type=script&lang=js"

import "./EndGameBuddy1.vue?vue&type=style&index=0&id=9a3f7542&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3f7542"]])

export default __exports__